import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=bf46951c&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf46951c')) {
      api.createRecord('bf46951c', component.options)
    } else {
      api.reload('bf46951c', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=bf46951c&", function () {
      api.rerender('bf46951c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Tabs.vue"
export default component.exports